<template>
    <div>
        <div class="d-flex align-items-center mb-1">
            <i :class="icon" class="mr-2 text-muted"></i>
            <span class="font-weight-semibold">{{ label }}</span>
            <span class="ml-auto font-weight-semibold tabular" style="white-space: nowrap;">{{ formatNumber(count) }}<span class="text-muted">&nbsp;/&nbsp;{{ formatNumber(limit) }}</span></span>
        </div>
        <div class="progress" style="height: 6px; border-radius: 3px;">
            <div :class="progressBarClass" role="progressbar" :style="{ width: progress + '%' }"></div>
        </div>
        <div class="d-flex justify-content-between font-size-xs text-muted mt-1">
            <span>{{ $t('paymentTable.limitRow.usedPercent', { percent: progress }) }}</span>
            <span>{{ $t('paymentTable.limitRow.remaining', { count: formatNumber(remaining) }) }}</span>
        </div>
    </div>
</template>
<script>
export default {
    name: "LimitRow",
    props: {
        icon: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        count: {
            type: Number,
            required: true
        },
        limit: {
            type: Number,
            required: true
        },
        formatNumber: {
            type: Function,
            required: true
        }
    },
    computed: {
        progress() {
            return (this.count / this.limit * 100).toFixed(0);
        },
        remaining() {
            return this.limit - this.count;
        },
        progressBarClass() {
            if (this.progress < 70) {
                return 'progress-bar bg-indigo';
            } else if (this.progress < 90) {
                return 'progress-bar bg-warning';
            } else {
                return 'progress-bar bg-danger';
            }
        }
    }
}
</script>